import { RouterRootView } from '@opengov/compose-app-router/components';
import { ComposeAppRenderer } from '@opengov/compose-app/renderApp';
import React, { useEffect, useMemo } from 'react';
import { ReportPage } from './components/ReportPage';
import { selectReportPageProps } from './components/ReportPage/selectors';
import { createStore } from './store';
import { IPageComponentProps, PageComponent } from './PageComponent';
import { useRouterStore } from './routes/routerStore';

const rootView = RouterRootView(ReportPage, selectReportPageProps);

export const { store } = createStore();

interface IReportingAppRendererProps {
  pageProps?: IPageComponentProps<unknown>;
}

export const ReportingAppRenderer = ({ pageProps }: IReportingAppRendererProps) => {
  const component = useMemo(() => (pageProps ? PageComponent(pageProps) : rootView), [pageProps]);
  const setParams = useRouterStore((state) => state.setParams);
  const setCurrentRouteName = useRouterStore((state) => state.setCurrentRouteName);

  useEffect(() => {
    return () => {
      setParams({});
    };
  }, []);
  useEffect(() => {
    setCurrentRouteName(pageProps?.name ?? '');
    return () => {
      setCurrentRouteName('');
    };
  }, [pageProps?.name]);

  return <ComposeAppRenderer store={store} rootView={component} selector={(state) => ({ state })} />;
};
